// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"34464e16","109":"b2ea8bb8"}[chunkId] + ".chunk.css";
};